import { SectionError } from '@/components/section-state';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';
import { DetailPanel } from './DetailPanel';
import type { Prompt } from './types';

interface PromptEditorProps {
  prompts: Prompt[];
  promptId: string;
  value: string;
  isError: boolean;
  error: unknown;
  onRetry: () => void;
  onSelect: (promptId: string) => void;
  onChange: (value: string) => void;
  onReset: () => void;
}

export const PromptEditor = ({
  prompts,
  promptId,
  value,
  isError,
  error,
  onRetry,
  onSelect,
  onChange,
  onReset,
}: PromptEditorProps) => (
  <>
    <div className="space-y-2 lg:col-span-2">
      <Label htmlFor="prompt-select">Grunnboð</Label>
      {isError && <SectionError title="Ekki tókst að sækja grunnboð" error={error} onRetry={onRetry} />}
      <Select value={promptId || undefined} onValueChange={onSelect}>
        <SelectTrigger id="prompt-select">
          <SelectValue placeholder="Veldu grunnboð" />
        </SelectTrigger>
        <SelectContent>
          {prompts.map((prompt) => (
            <SelectItem key={prompt.id} value={prompt.id}>
              {prompt.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>

    <div className="lg:col-span-2">
      <DetailPanel label="Kerfisboð" count={value.length}>
        <div className="mt-2 space-y-2">
          <Label htmlFor="prompt" className="sr-only">
            Kerfisboð
          </Label>
          <div className="flex justify-end">
            <Button type="button" variant="ghost" size="sm" onClick={onReset} disabled={!promptId}>
              Endurstilla
            </Button>
          </div>
          <Textarea id="prompt" value={value} onChange={(event) => onChange(event.target.value)} rows={10} />
          <p className="text-muted-foreground text-xs">
            Kerfisboðið er byggt eins og í raunkeyrslu, að undanskildu samhengi fyrir komu (pre-encounter) og tilvísunum
            í umritun, sem hvorugt er hægt að endurgera út frá geymdri lotu.
          </p>
        </div>
      </DetailPanel>
    </div>
  </>
);
